import { values } from 'lodash'

type Route = {
  path?: string | null
}
export const routes = new Set<string>()
export const setRoutes = <T extends { [key in string]: Route }>(
  routesObj: T | Route[],
) => {
  routes.clear()
  values(routesObj)
    .map(({ path }) => path)
    .filter((v) => !!v)
    .forEach((v: string) => routes.add(v))
}
